import React, { useState, useEffect, useMemo } from "react";
import Stack from "@mui/material/Stack";

import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import AlarmIcon from "@mui/icons-material/Alarm";
import IconButton from "@mui/material/IconButton";
import Avatar from "@mui/material/Avatar";
import { worktypeOptionType } from "../ScheduleHeader";
import { IScheduleEvent } from "../../../redux/reducers/schedule.reducer";
import { ColorCodeType } from "../../MonthlyCalendar/MonthlyCalendar";
import NightsStayIcon from "@mui/icons-material/NightsStay";
import moment from "moment";

import FiberNewIcon from "@mui/icons-material/FiberNew";
import { loadSingleEvent } from "../../../redux/actions/schedule.actions";
import { useAppDispatch } from "../../../redux/store";
import {
  IFacilityOption,
  eventForm,
} from "../../CalendarForms/Types/calendarTypes";

type PropsType = {
  date: string;
  allEvents: IScheduleEvent[];
  fullDate: string;
  dayString: string;
  workfield: worktypeOptionType;
  setShowEditModal: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedEvent: React.Dispatch<React.SetStateAction<IScheduleEvent | null>>;
  setShowingEventForm: React.Dispatch<React.SetStateAction<eventForm>>;
  selectedFacility: IFacilityOption | null;
  filterByWorktype: string[];
  setShowAssignEmployeeModal: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function LoadEvents(props: PropsType) {
  const {
    fullDate,
    allEvents,
    setSelectedEvent,
    setShowEditModal,
    filterByWorktype,
    setShowAssignEmployeeModal,
    workfield,
  } = props;

  const dispatch = useAppDispatch();

  const [dayEvent, setDayEvent] = useState<any[]>([]);

  useEffect(() => {
    let dayAllEvents: IScheduleEvent[] = [];
    allEvents.forEach((event) => {
      //checking if in same date
      if (
        event.schedule_date === fullDate &&
        workfield.id === event.work_type
      ) {
        //filtering work type it is also filtered by backend too
        if (filterByWorktype.length) {
          if (filterByWorktype.includes(event.work_type))
            dayAllEvents.push(event);
        } else {
          dayAllEvents.push(event);
        }
      }
    });

    allEvents.sort((a: IScheduleEvent, b: IScheduleEvent) => {
      return +a.schedule_status - +b.schedule_status;
    });

    setDayEvent(dayAllEvents);

    // setting day event to empty array when component exits
    return () => {
      setDayEvent([]);
    };
  }, [fullDate, allEvents, filterByWorktype, workfield.id]);

  function handleEventSelect(e: any, selectedEvent: IScheduleEvent) {
    setSelectedEvent(selectedEvent);
    setShowEditModal(true);
  }

  function handleAssignEmployee(
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    selectedEvent: IScheduleEvent
  ) {
    // let currentDate = new Date();
    // let scheduleDate = new Date(selectedEvent.end_time);
    // if (currentDate <= scheduleDate) {
    dispatch(loadSingleEvent(selectedEvent?.id));

    setSelectedEvent(selectedEvent);
    setShowAssignEmployeeModal(true);
    // }
    e.stopPropagation();
  }
  let colorCodes: ColorCodeType = useMemo(
    () => ({
      0: "#404040", //dark grey --closed
      1: " #006400", //green --open
      2: "#4169E1", //light blue --unassigned
      3: "#AA2C2C", //dark red --unfullfilled
      4: "#022e1f", //tomato red --cancelled
      5: " #191970", //royal blue --assigned
    }),
    []
  );

  function renderEvents() {
    return dayEvent.map((event: IScheduleEvent) => {
      let isPastEvent = false;
      let currentDateObj = moment();

      let startTimeObj = moment(event.start_time);
      let endTimeObj = moment(event.end_time);
      let isOvernight = false;
      if (currentDateObj >= endTimeObj) isPastEvent = true;
      if (
        startTimeObj?.format("YYYY-MM-DD") !== endTimeObj?.format("YYYY-MM-DD")
      ) {
        isOvernight = true;
      }

      return (
        <Box key={event.id}>
          <Box
            className="schedule-event"
            onClick={(e) => handleEventSelect(e, event)}
            px={1}
            borderRadius={"5px"}
            width={"92%"}
            margin={"auto"}
            sx={{
              backgroundColor: isPastEvent ? "#e0e0e0" : "#FAFAFA",
              boxShadow: "2px 2px 6px 1px #878378;",
              cursor: "pointer",
            }}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems={"center"}
            >
              <Box
                className="time-container"
                display="flex"
                flexWrap="wrap"
                typography={"caption"}
                color="black"
                fontWeight={600}
              >
                <Box
                  className="event-typography"
                  display="flex"
                  alignItems="center"
                >
                  <AlarmIcon sx={{ height: "15px", width: "15px", mr: 0.5 }} />
                  {event.start_time.slice(11, 16)}~
                </Box>
                <Box
                  className="event-typography"
                  display="flex"
                  alignItems="center"
                >
                  {event.end_time.slice(11, 16)}
                </Box>
              </Box>

              {isOvernight && <NightsStayIcon sx={{ height: "18px" }} />}
            </Box>
            <Box
              display={"flex"}
              flexWrap="wrap"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box onClick={(e) => handleAssignEmployee(e, event)}>
                {event.assigned_to ? (
                  <IconButton key={event.assigned_to.id} sx={{ p: 0 }}>
                    <Avatar
                      title={`${event.assigned_to.fullname}`}
                      sx={{
                        height: "20px",
                        width: "20px",
                        fontSize: "10px",
                        backgroundColor: "primary.main",
                      }}
                      alt={`${event.assigned_to.fullname}`}
                      src={event.assigned_to.avatar ?? "null"}
                    />
                  </IconButton>
                ) : (
                  <IconButton key={"add"} sx={{ p: 0 }}>
                    <Avatar
                      sx={{ height: "20px", width: "20px" }}
                      alt={"+"}
                      src={"null"}
                    />
                  </IconButton>
                )}
              </Box>

              {+event?.schedule_status === 0 && (
                <Typography
                  className="event-typography"
                  flex={1}
                  color={colorCodes[event?.schedule_status]}
                  fontWeight="600"
                  my={0.5}
                  textAlign="right"
                  sx={{
                    p: 0.5,
                    px: 1,
                    borderRadius: "4px",
                    width: "min-content",
                    marginLeft: "auto",
                  }}
                >
                  Closed
                </Typography>
              )}
              {+event?.schedule_status === 1 && (
                <Typography
                  className="event-typography"
                  flex={1}
                  fontWeight="600"
                  color={colorCodes[event?.schedule_status]}
                  my={0.5}
                  textAlign="right"
                  sx={{
                    p: 0.5,
                    px: 1,
                    borderRadius: "4px",
                    width: "min-content",
                    marginLeft: "auto",
                  }}
                >
                  Opened
                </Typography>
              )}
              {+event?.schedule_status === 2 && (
                <Typography
                  className="event-typography"
                  flex={1}
                  fontWeight="600"
                  color={colorCodes[event?.schedule_status]}
                  my={0.5}
                  textAlign="right"
                  sx={{
                    p: 0.5,
                    px: 1,
                    borderRadius: "4px",
                    width: "min-content",
                    marginLeft: "auto",
                  }}
                >
                  Unassigned
                </Typography>
              )}
              {+event?.schedule_status === 3 && (
                <Typography
                  className="event-typography"
                  flex={1}
                  fontWeight="600"
                  color={colorCodes[event?.schedule_status]}
                  my={0.5}
                  textAlign="right"
                  sx={{
                    p: 0.5,
                    px: 1,
                    borderRadius: "4px",
                    width: "min-content",
                    marginLeft: "auto",
                  }}
                >
                  Unfulfilled
                </Typography>
              )}
              {+event?.schedule_status === 4 && (
                <Typography
                  className="event-typography"
                  flex={1}
                  fontWeight="600"
                  color={colorCodes[event?.schedule_status]}
                  my={0.5}
                  textAlign="right"
                  sx={{
                    p: 0.5,
                    px: 1,
                    borderRadius: "4px",
                    width: "min-content",
                    marginLeft: "auto",
                  }}
                >
                  Fulfilled
                </Typography>
              )}
              {+event?.schedule_status === 5 && (
                <Typography
                  className="event-typography"
                  flex={1}
                  fontWeight="600"
                  color={colorCodes[event?.schedule_status]}
                  my={0.5}
                  textAlign="right"
                  sx={{
                    p: 0.5,
                    px: 1,
                    borderRadius: "4px",
                    width: "min-content",
                    marginLeft: "auto",
                  }}
                >
                  Assigned
                </Typography>
              )}
              {event?.new_schedule && (
                <FiberNewIcon sx={{ alignSelf: "center" }} />
              )}
            </Box>
          </Box>
        </Box>
      );
    });
  }
  return (
    <Stack
      spacing={2}
      sx={{ width: "14.28%" }}
      border="1px solid rgba(0,0,0,0.15)"
      style={{ borderTop: 0, borderBottom: 0 }}
    >
      {renderEvents()}
    </Stack>
  );
}
